import IncidentCategoriesAtAGlanceGraph from './IncidentCategoriesAtAGlanceGraph';

export default IncidentCategoriesAtAGlanceGraph;
